export const ownerProfile = {
  id: "usr-owner-1",
  name: "Ramesh Gowda",
  email: "owner@mysoreyellowpages.com",
  phone: "+91 81235 84806",
  company: "Mylari Group of Businesses",
  city: "Mysore",
  avatar: "https://readdy.ai/api/search-image?query=Warm%20portrait%20of%20a%20friendly%20middle%20aged%20Indian%20businessman%20in%20a%20light%20shirt%20smiling%2C%20soft%20neutral%20cream%20studio%20background%2C%20editorial%20headshot%20photography%2C%20natural%20light&width=400&height=400&seq=myyp-owner-avatar&orientation=squarish",
  plan: "Premium",
  memberSince: "2023-04-18",
  role: "owner",
};

export const ownerListings = [
  {
    id: "biz-1",
    name: "Mylari Mane Restaurant",
    slug: "mylari-mane-restaurant",
    categoryId: "cat-restaurants",
    categoryName: "Restaurants",
    locationId: "loc-mysore",
    locationName: "Mysore",
    description: "Authentic Mysore-style dosa and filter coffee served fresh since 1978. A local breakfast institution near Sayyaji Rao Road.",
    phone: "+91 81235 84806",
    email: "hello@mylarimane.in",
    website: "https://mylarimane.in",
    address: "Sayyaji Rao Road, Mysore, Karnataka 570001",
    image: "https://readdy.ai/api/search-image?query=Warm%20crispy%20Mysore%20masala%20dosa%20on%20a%20banana%20leaf%20with%20coconut%20chutney%20and%20filter%20coffee%2C%20rustic%20wooden%20table%2C%20soft%20natural%20light%2C%20appetizing%20food%20photography%2C%20warm%20tones&width=800&height=600&seq=myyp-biz-1&orientation=landscape",
    rating: 4.7,
    reviewCount: 1284,
    isFeatured: true,
    isVerified: true,
    status: "approved",
    plan: "Premium",
    openNow: true,
    hours: "6:30 AM - 10:00 PM",
    tags: ["Dosa", "Breakfast", "South Indian"],
    views: 18420,
    leads: 268,
    photos: 9,
    updatedAt: "2026-10-04",
  },
  {
    id: "biz-2",
    name: "Cauvery Grand Hotel",
    slug: "cauvery-grand-hotel",
    categoryId: "cat-hotels",
    categoryName: "Hotels",
    locationId: "loc-mysore",
    locationName: "Mysore",
    description: "Boutique business hotel two kilometres from Mysore Palace with rooftop dining and conference halls.",
    phone: "+91 81235 84807",
    email: "reservations@cauverygrand.in",
    website: "https://cauverygrand.in",
    address: "Bannur Road, Mysore, Karnataka 570011",
    image: "https://readdy.ai/api/search-image?query=Elegant%20boutique%20hotel%20lobby%20with%20warm%20wood%20panels%2C%20brass%20lamps%20and%20marble%20floor%2C%20hospitality%20interior%20photography%2C%20amber%20and%20cream%20tones&width=800&height=600&seq=myyp-biz-2&orientation=landscape",
    rating: 4.5,
    reviewCount: 612,
    isFeatured: true,
    isVerified: true,
    status: "approved",
    plan: "Premium",
    openNow: true,
    hours: "24 hours",
    tags: ["Hotel", "Rooms", "Conference"],
    views: 11260,
    leads: 194,
    photos: 12,
    updatedAt: "2026-09-29",
  },
  {
    id: "biz-4",
    name: "Akshara Academy Coaching",
    slug: "akshara-academy-coaching",
    categoryId: "cat-education",
    categoryName: "Education",
    locationId: "loc-mysore",
    locationName: "Mysore",
    description: "NEET, JEE and PU coaching with small batches, mock tests and personal mentoring by experienced faculty.",
    phone: "+91 81235 84809",
    email: "admissions@aksharaacademy.in",
    website: "https://aksharaacademy.in",
    address: "Kuvempunagar, Mysore, Karnataka 570023",
    image: "https://readdy.ai/api/search-image?query=Bright%20modern%20coaching%20classroom%20with%20wooden%20desks%2C%20green%20chalkboard%20and%20large%20windows%2C%20warm%20daylight%2C%20education%20photography&width=800&height=600&seq=myyp-biz-4&orientation=landscape",
    rating: 4.8,
    reviewCount: 254,
    isFeatured: false,
    isVerified: true,
    status: "approved",
    plan: "Standard",
    openNow: false,
    hours: "8:00 AM - 8:00 PM",
    tags: ["NEET", "JEE", "Coaching"],
    views: 7630,
    leads: 121,
    photos: 6,
    updatedAt: "2026-09-21",
  },
  {
    id: "biz-10",
    name: "GreenLeaf Home Services",
    slug: "greenleaf-home-services",
    categoryId: "cat-homeservices",
    categoryName: "Home Services",
    locationId: "loc-mysore",
    locationName: "Mysore",
    description: "Verified electricians, plumbers, carpenters and deep-cleaning crews on call across Mysore city.",
    phone: "+91 81235 84815",
    email: "book@greenleafhome.in",
    website: "https://greenleafhome.in",
    address: "Ramanuja Road, Mysore, Karnataka 570004",
    image: "https://readdy.ai/api/search-image?query=Friendly%20home%20service%20technician%20in%20uniform%20with%20toolkit%20at%20a%20bright%20doorway%2C%20trustworthy%20warm%20editorial%20photography%2C%20cream%20and%20green%20tones&width=800&height=600&seq=myyp-biz-10&orientation=landscape",
    rating: 4.5,
    reviewCount: 287,
    isFeatured: true,
    isVerified: true,
    status: "approved",
    plan: "Standard",
    openNow: true,
    hours: "8:00 AM - 9:00 PM",
    tags: ["Plumbing", "Electrical", "Cleaning"],
    views: 9240,
    leads: 156,
    photos: 8,
    updatedAt: "2026-10-01",
  },
  {
    id: "biz-13",
    name: "Mylari Mane Cloud Kitchen",
    slug: "mylari-mane-cloud-kitchen",
    categoryId: "cat-restaurants",
    categoryName: "Restaurants",
    locationId: "loc-mysore",
    locationName: "Mysore",
    description: "Delivery-only kitchen serving Mylari favourites — idli, dosa and combo meals across Mysore city.",
    phone: "+91 81235 84806",
    email: "delivery@mylarimane.in",
    website: "",
    address: "Vijayanagar 1st Stage, Mysore, Karnataka 570017",
    image: "https://readdy.ai/api/search-image?query=Neat%20takeaway%20food%20packaging%20with%20South%20Indian%20breakfast%20items%20on%20a%20warm%20wooden%20surface%2C%20clean%20appetizing%20food%20photography%2C%20amber%20tones&width=800&height=600&seq=myyp-biz-13&orientation=landscape",
    rating: 0,
    reviewCount: 0,
    isFeatured: false,
    isVerified: false,
    status: "pending",
    plan: "Free",
    openNow: true,
    hours: "7:00 AM - 11:00 PM",
    tags: ["Delivery", "Breakfast", "Combos"],
    views: 0,
    leads: 0,
    photos: 2,
    updatedAt: "2026-10-09",
  },
];

export const ownerOrders = [
  { id: "ord-1024", orderNo: "MYP-1024", invoiceNo: "INV-2026-1024", planName: "Premium — Annual", amount: 2499, status: "paid", paymentMode: "UPI", createdAt: "2026-04-18" },
  { id: "ord-1108", orderNo: "MYP-1108", invoiceNo: "INV-2026-1108", planName: "Standard — Annual (Akshara)", amount: 999, status: "paid", paymentMode: "Card", createdAt: "2026-05-02" },
  { id: "ord-1187", orderNo: "MYP-1187", invoiceNo: "INV-2026-1187", planName: "Premium — Photos add-on", amount: 600, status: "paid", paymentMode: "UPI", createdAt: "2026-06-14" },
  { id: "ord-1240", orderNo: "MYP-1240", invoiceNo: "INV-2026-1240", planName: "Homepage feature — 30 days", amount: 1500, status: "pending", paymentMode: "Net Banking", createdAt: "2026-09-27" },
  { id: "ord-1265", orderNo: "MYP-1265", invoiceNo: "INV-2026-1265", planName: "Standard — Annual (GreenLeaf)", amount: 999, status: "paid", paymentMode: "UPI", createdAt: "2026-08-11" },
  { id: "ord-1298", orderNo: "MYP-1298", invoiceNo: "INV-2026-1298", planName: "Banner ad credit", amount: 800, status: "refunded", paymentMode: "Card", createdAt: "2026-07-30" },
];

export const ownerReviews = [
  { id: "orev-1", businessId: "biz-1", businessName: "Mylari Mane Restaurant", authorName: "Sneha Rao", rating: 5, comment: "The benne dosa is exactly how I remember it. Quick service and honest prices.", date: "2026-09-28", replied: false },
  { id: "orev-2", businessId: "biz-2", businessName: "Cauvery Grand Hotel", authorName: "Karthik Iyer", rating: 5, comment: "Clean rooms, great rooftop dinner and very helpful front desk. Will stay again.", date: "2026-09-21", replied: true },
  { id: "orev-3", businessId: "biz-10", businessName: "GreenLeaf Home Services", authorName: "Suresh Kumar", rating: 4, comment: "Plumber arrived on time and fixed the leak quickly. Fair charges.", date: "2026-08-22", replied: false },
  { id: "orev-4", businessId: "biz-1", businessName: "Mylari Mane Restaurant", authorName: "Anita P", rating: 5, comment: "Still the best benne dosa in Mysore after all these years. Worth the queue.", date: "2026-09-30", replied: false },
  { id: "orev-5", businessId: "biz-4", businessName: "Akshara Academy Coaching", authorName: "Meghana H", rating: 5, comment: "My daughter's NEET score jumped after joining. Faculty really care about each student.", date: "2026-09-26", replied: true },
  { id: "orev-6", businessId: "biz-2", businessName: "Cauvery Grand Hotel", authorName: "Ravi Shankar", rating: 3, comment: "Good location but the breakfast spread could be wider.", date: "2026-09-12", replied: false },
];

export const ownerMedia = [
  { id: "med-1", url: "https://readdy.ai/api/search-image?query=Warm%20crispy%20Mysore%20masala%20dosa%20on%20a%20banana%20leaf%20with%20coconut%20chutney%20and%20filter%20coffee%2C%20rustic%20wooden%20table%2C%20soft%20natural%20light%2C%20appetizing%20food%20photography%2C%20warm%20tones&width=800&height=600&seq=myyp-biz-1&orientation=landscape", name: "mylari-dosa-hero.jpg", listingId: "biz-1", listingName: "Mylari Mane Restaurant", size: "412 KB", uploadedAt: "2026-10-04" },
  { id: "med-2", url: "https://readdy.ai/api/search-image?query=Elegant%20boutique%20hotel%20lobby%20with%20warm%20wood%20panels%2C%20brass%20lamps%20and%20marble%20floor%2C%20hospitality%20interior%20photography%2C%20amber%20and%20cream%20tones&width=800&height=600&seq=myyp-biz-2&orientation=landscape", name: "cauvery-lobby.jpg", listingId: "biz-2", listingName: "Cauvery Grand Hotel", size: "638 KB", uploadedAt: "2026-09-29" },
  { id: "med-3", url: "https://readdy.ai/api/search-image?query=Bright%20modern%20coaching%20classroom%20with%20wooden%20desks%2C%20green%20chalkboard%20and%20large%20windows%2C%20warm%20daylight%2C%20education%20photography&width=800&height=600&seq=myyp-biz-4&orientation=landscape", name: "akshara-classroom.jpg", listingId: "biz-4", listingName: "Akshara Academy Coaching", size: "355 KB", uploadedAt: "2026-09-21" },
  { id: "med-4", url: "https://readdy.ai/api/search-image?query=Friendly%20home%20service%20technician%20in%20uniform%20with%20toolkit%20at%20a%20bright%20doorway%2C%20trustworthy%20warm%20editorial%20photography%2C%20cream%20and%20green%20tones&width=800&height=600&seq=myyp-biz-10&orientation=landscape", name: "greenleaf-team.jpg", listingId: "biz-10", listingName: "GreenLeaf Home Services", size: "289 KB", uploadedAt: "2026-10-01" },
  { id: "med-5", url: "https://readdy.ai/api/search-image?query=Neat%20takeaway%20food%20packaging%20with%20South%20Indian%20breakfast%20items%20on%20a%20warm%20wooden%20surface%2C%20clean%20appetizing%20food%20photography%2C%20amber%20tones&width=800&height=600&seq=myyp-biz-13&orientation=landscape", name: "cloud-kitchen-pack.jpg", listingId: "biz-13", listingName: "Mylari Mane Cloud Kitchen", size: "301 KB", uploadedAt: "2026-10-09" },
  { id: "med-6", url: "https://readdy.ai/api/search-image?query=Close%20up%20of%20filter%20coffee%20being%20poured%20into%20a%20steel%20tumbler%20at%20a%20traditional%20Indian%20restaurant%2C%20warm%20steam%20and%20golden%20light%2C%20food%20photography&width=800&height=600&seq=myyp-owner-media-6&orientation=landscape", name: "filter-coffee.jpg", listingId: "biz-1", listingName: "Mylari Mane Restaurant", size: "276 KB", uploadedAt: "2026-09-18" },
];

export const ownerTrend = [
  { label: "Mar", views: 6120, leads: 74 },
  { label: "Apr", views: 7480, leads: 96 },
  { label: "May", views: 8210, leads: 108 },
  { label: "Jun", views: 9040, leads: 121 },
  { label: "Jul", views: 9880, leads: 139 },
  { label: "Aug", views: 11240, leads: 158 },
  { label: "Sep", views: 12960, leads: 176 },
  { label: "Oct", views: 14210, leads: 192 },
];

export const ownerDashboardStats = {
  totalListings: 5,
  approvedListings: 4,
  pendingListings: 1,
  profileViews: 14210,
  totalLeads: 739,
  avgRating: 4.6,
  totalReviews: 2437,
  viewsChange: 9.6,
  leadsChange: 8.8,
};

export const ownerDemoAccount = {
  email: "owner@mysoreyellowpages.com",
  password: "demo1234",
};